// Behance'dan alınan tüm 46 Medyatik projesi
// Görseller /public/projects/ klasöründe barındırılıyor

export const allProjects = [
  // ===== SAYFA 1 (İlk 12) =====
  {
    id: 'innovacare',
    slug: 'innovacare-saglik-turizmi',
    title: 'İnnovacare - Sağlık Turizmi',
    client: 'İnnovacare',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/innovacare.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194664113/Medyatik-nnovacare-Saglk-turizmi',
    metric: '+180%',
    metricLabel: 'Hasta Başvurusu',
    description: 'Sağlık turizmi alanında uluslararası hastalar için kapsamlı dijital deneyim ve web platformu tasarımı.',
    challenge: 'Uluslararası hastalar için güven oluşturacak, çok dilli ve kolay navigasyon sağlayan bir platform ihtiyacı.',
    solution: 'Nöro-UX prensipleri ile tasarlanan kullanıcı yolculuğu, güven sinyalleri ve kolay randevu sistemi entegrasyonu.',
    results: ['%180 hasta başvuru artışı', '%65 bounce rate düşüşü', '%240 organik trafik artışı'],
    services: ['Web Tasarım', 'UX/UI', 'SEO', 'Çok Dilli Platform'],
    year: '2024',
  },
  {
    id: 'trendy-art',
    slug: 'trendy-art',
    title: 'Trendy Art',
    client: 'Trendy Art',
    category: 'branding',
    categoryLabel: 'Marka & Kurumsal',
    image: '/projects/trendy-art.png',
    behanceUrl: 'https://www.behance.net/gallery/194663601/Medyatik-Trendy-Art',
    metric: '+220%',
    metricLabel: 'Online Satış',
    description: 'Sanat galerisi için modern ve şık kurumsal kimlik ve web sitesi tasarımı.',
    challenge: 'Sanat eserlerinin dijital ortamda değerini koruyarak sergilenmesi ve satış dönüşümünün artırılması.',
    solution: 'Minimalist tasarım ile eserlerin ön plana çıkarılması, galeri benzeri dijital deneyim oluşturulması.',
    results: ['%220 online satış artışı', '%150 ziyaretçi etkileşimi', 'Marka bilinirliği artışı'],
    services: ['Kurumsal Kimlik', 'Web Tasarım', 'E-Ticaret'],
    year: '2024',
  },
  {
    id: 'k-lotus-beauty',
    slug: 'k-lotus-beauty',
    title: 'K-Lotus Beauty - Senin Cildin Senin Rutinin',
    client: 'K-Lotus Beauty',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/k-lotus-beauty.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194662091/Medyatik-K-Lotus-Beauty-Senin-Cildin-Senin-Rutinin',
    metric: '+340%',
    metricLabel: 'Dönüşüm',
    description: 'Kore kozmetik markası için e-ticaret platformu ve dijital pazarlama stratejisi.',
    challenge: 'Yoğun rekabetçi kozmetik pazarında farklılaşma ve müşteri sadakati oluşturma.',
    solution: 'Kişiselleştirilmiş ürün önerileri, cilt analizi aracı ve abonelik modeli entegrasyonu.',
    results: ['%340 dönüşüm artışı', '%280 sepet değeri artışı', '%190 müşteri sadakati'],
    services: ['E-Ticaret', 'UX/UI', 'Dijital Pazarlama', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'wetnose',
    slug: 'wetnose-veteriner',
    title: 'Wetnose Veteriner Kliniği',
    client: 'Wetnose',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/wetnose.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194628259/Medyatik-Wetnose-Veteriner-Klinigi',
    metric: '+290%',
    metricLabel: 'Randevu',
    description: 'Veteriner kliniği için randevu sistemi entegreli modern web sitesi ve sosyal medya yönetimi.',
    challenge: 'Pet sahiplerinin acil durumlarda hızlı randevu alabilmesi ve klinik hizmetlerinin tanıtımı.',
    solution: 'Tek tıkla randevu sistemi, 7/24 acil hat vurgusu ve güven oluşturan testimonial entegrasyonu.',
    results: ['%290 randevu artışı', '%200 sosyal medya etkileşimi', 'Marka güvenilirliği'],
    services: ['Web Tasarım', 'Randevu Sistemi', 'Sosyal Medya', 'SEO'],
    year: '2024',
  },
  {
    id: 'anticorex',
    slug: 'anticorex-coviral',
    title: 'Anticorex - Coviral',
    client: 'Anticorex',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/anticorex.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194625707/Medyatik-Anticorex-Coviral',
    metric: '+150%',
    metricLabel: 'Satış',
    description: 'Sağlık ürünleri markası için bilgilendirici web platformu ve e-ticaret entegrasyonu.',
    challenge: 'Sağlık ürünlerinde güvenilirlik ve bilimsel kanıt sunumu.',
    solution: 'Bilimsel araştırma ve sertifika vurgulu içerik stratejisi, güven odaklı tasarım.',
    results: ['%150 satış artışı', '%180 site trafiği', 'Güvenilir marka algısı'],
    services: ['Web Tasarım', 'E-Ticaret', 'İçerik Stratejisi'],
    year: '2024',
  },
  {
    id: 'sasasapanca',
    slug: 'sasasapanca',
    title: 'Sasasapanca',
    client: 'Sasasapanca',
    category: 'tourism',
    categoryLabel: 'Turizm & Otel',
    image: '/projects/sasasapanca.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194620071/Medyatik-Sasasapanca',
    metric: '+420%',
    metricLabel: 'Rezervasyon',
    description: 'Sapanca bölgesi turizm ve konaklama için rezervasyon sistemi entegreli web platformu.',
    challenge: 'Bölgesel turizmin dijitalde görünürlüğü ve kolay rezervasyon deneyimi.',
    solution: 'Görsel odaklı tasarım, anlık müsaitlik gösterimi ve tek adımda rezervasyon sistemi.',
    results: ['%420 rezervasyon artışı', '%300 organik arama trafiği', 'Bölgesel otorite'],
    services: ['Web Tasarım', 'Rezervasyon Sistemi', 'SEO', 'Fotoğrafçılık'],
    year: '2024',
  },
  {
    id: 'kids-a-more',
    slug: 'kids-a-more',
    title: 'Kids A more',
    client: 'Kids A more',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/kids-a-more.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194619207/Medyatik-Kids-A-more',
    metric: '+280%',
    metricLabel: 'Online Satış',
    description: 'Çocuk giyim markası için e-ticaret platformu ve dijital pazarlama stratejisi.',
    challenge: 'Anne-baba hedef kitlesine güven veren, kolay alışveriş deneyimi.',
    solution: 'Yaş ve beden filtreleme, güvenli ödeme vurgusu, hızlı teslimat garantisi.',
    results: ['%280 online satış artışı', '%200 müşteri memnuniyeti', 'Sadık müşteri tabanı'],
    services: ['E-Ticaret', 'UX/UI', 'Dijital Pazarlama'],
    year: '2024',
  },
  {
    id: 'eczaonline',
    slug: 'eczaonline',
    title: 'Eczaonline - Sağlık ve Güzelliğin Adresi',
    client: 'Eczaonline',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/eczaonline.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194600305/Medyatik-Eczaonline-Saglk-ve-Guezelligin-Adresi',
    metric: '+520%',
    metricLabel: 'Trafik',
    description: 'Online eczane platformu için kapsamlı e-ticaret çözümü ve sosyal medya yönetimi.',
    challenge: 'Güvenli ve hızlı ilaç tedariki, reçeteli/reçetesiz ürün ayrımı.',
    solution: 'Kullanıcı dostu arayüz, reçete yükleme sistemi, eczacı danışmanlık hattı.',
    results: ['%520 trafik artışı', '%350 satış artışı', 'Sektör liderliği'],
    services: ['E-Ticaret', 'Web Tasarım', 'Sosyal Medya', 'SEO'],
    year: '2024',
  },
  {
    id: 'enmama',
    slug: 'enmama',
    title: 'Enmama - En\'ler Burada',
    client: 'Enmama',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/enmama.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194597923/Medyatik-Enmama-Enler-Burada',
    metric: '+380%',
    metricLabel: 'Satıcı Kaydı',
    description: 'E-ticaret marketplace platformu tasarımı ve geliştirmesi.',
    challenge: 'Hem satıcı hem alıcı için kullanışlı çift taraflı marketplace yapısı.',
    solution: 'Kolay satıcı paneli, alıcı koruma sistemi, kategori bazlı navigasyon.',
    results: ['%380 satıcı kaydı artışı', '%250 işlem hacmi', 'Platform büyümesi'],
    services: ['Marketplace', 'Web Geliştirme', 'UX/UI'],
    year: '2024',
  },
  {
    id: 'petqueen',
    slug: 'petqueen',
    title: 'PetQueen',
    client: 'PetQueen',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/petqueen.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194577443/Medyatik-PetQueen',
    metric: '+310%',
    metricLabel: 'Sipariş',
    description: 'Pet shop e-ticaret platformu ve marka kimliği tasarımı.',
    challenge: 'Pet sahiplerinin ihtiyaçlarını hızlı karşılayan, güvenilir platform.',
    solution: 'Pet türüne göre filtreleme, abonelik modeli, hızlı teslimat vurgusu.',
    results: ['%310 sipariş artışı', '%220 müşteri sadakati', 'Marka bilinirliği'],
    services: ['E-Ticaret', 'Kurumsal Kimlik', 'Web Tasarım'],
    year: '2024',
  },
  {
    id: 'yemburada',
    slug: 'yemburada-deltacanli',
    title: 'YemBurada - DeltaCanlı',
    client: 'DeltaCanlı',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/yemburada.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194576689/Medyatik-YemBurada-DeltaCanl',
    metric: '+250%',
    metricLabel: 'B2B Satış',
    description: 'Hayvan yemi e-ticaret platformu ve B2B satış sistemi.',
    challenge: 'Tarım sektöründe dijital dönüşüm ve B2B sipariş yönetimi.',
    solution: 'Toplu sipariş sistemi, bayi paneli, otomatik stok takibi.',
    results: ['%250 B2B satış artışı', '%180 bayi kaydı', 'Sektör dijitalizasyonu'],
    services: ['B2B E-Ticaret', 'Web Geliştirme', 'ERP Entegrasyonu'],
    year: '2024',
  },
  {
    id: 'medyatik-office',
    slug: 'medyatik-office',
    title: 'Medyatik Office',
    client: 'Medyatik Interactive',
    category: 'branding',
    categoryLabel: 'Marka & Kurumsal',
    image: '/images/projects/medyatik-office/office-01.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194598201/Medyatik-Office',
    metric: '20+',
    metricLabel: 'Yıl Deneyim',
    description: 'Medyatik Interactive ofis tasarımı ve kurumsal kimlik çalışması.',
    challenge: 'Yaratıcı ajans kimliğini yansıtan çalışma alanı tasarımı.',
    solution: 'Marka renkleri ve değerlerini yansıtan, ilham verici ofis tasarımı.',
    results: ['Ekip motivasyonu artışı', 'Marka tutarlılığı', 'Müşteri izlenimi'],
    services: ['İç Mekan Tasarım', 'Kurumsal Kimlik', 'Mimari Tasarım', '3D Render'],
    year: '2020',
    gallery: [
      '/images/projects/medyatik-office/office-01.jpg',
      '/images/projects/medyatik-office/office-02.jpg',
      '/images/projects/medyatik-office/office-03.jpg',
      '/images/projects/medyatik-office/office-04.jpg',
      '/images/projects/medyatik-office/office-05.jpg',
      '/images/projects/medyatik-office/office-06.jpg',
      '/images/projects/medyatik-office/office-07.jpg',
      '/images/projects/medyatik-office/office-08.jpg',
      '/images/projects/medyatik-office/office-09.jpg',
      '/images/projects/medyatik-office/office-10.jpg',
      '/images/projects/medyatik-office/office-11.jpg',
      '/images/projects/medyatik-office/office-12.jpg',
      '/images/projects/medyatik-office/office-13.jpg',
    ],
  },
  // ===== SAYFA 2 (13-24) =====
  {
    id: 'ibrahim-biyikli',
    slug: 'ibrahim-biyikli-koto',
    title: 'İbrahim BIYIKLI - Koto Başkan Adayı',
    client: 'İbrahim BIYIKLI',
    category: 'political',
    categoryLabel: 'Siyasi Kampanya',
    image: '/projects/ibrahim-biyikli.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194576003/Medyatik-brahim-BIYIKLI-Koto-Baskan-Aday',
    metric: '+340%',
    metricLabel: 'Sosyal Erişim',
    description: 'Kocaeli Ticaret Odası başkan adayı için siyasi kampanya ve dijital strateji.',
    challenge: 'Seçim döneminde hedef kitleye etkili ulaşım ve güven oluşturma.',
    solution: 'Kişisel marka oluşturma, sosyal medya stratejisi, dijital reklam kampanyası.',
    results: ['%340 sosyal erişim', 'Yüksek tanınırlık', 'Başarılı kampanya'],
    services: ['Siyasi Kampanya', 'Sosyal Medya', 'Dijital Reklam'],
    year: '2024',
  },
  {
    id: 'devfest-google',
    slug: 'devfest-google-sponsoru',
    title: 'DevFest Google Sponsoru',
    client: 'DevFest',
    category: 'event',
    categoryLabel: 'Etkinlik',
    image: '/projects/devfest-google.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194574897/Medyatik-DevFest-Google-Sponsoru',
    metric: '5000+',
    metricLabel: 'Katılımcı',
    description: 'Google DevFest etkinliği için sponsorluk ve tanıtım çalışması.',
    challenge: 'Teknoloji topluluğuna ulaşım ve marka görünürlüğü.',
    solution: 'Etkinlik sponsorluğu, dijital tanıtım, topluluk etkileşimi.',
    results: ['5000+ katılımcıya erişim', 'Marka bilinirliği', 'Topluluk ilişkileri'],
    services: ['Etkinlik Sponsorluğu', 'Dijital Pazarlama'],
    year: '2024',
  },
  {
    id: 'bipet',
    slug: 'bipet',
    title: 'Bipet',
    client: 'Bipet',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/bipet.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194574353/Medyatik-Bipet',
    metric: '+260%',
    metricLabel: 'Dönüşüm',
    description: 'Pet ürünleri e-ticaret platformu tasarımı ve geliştirmesi.',
    challenge: 'Pet sektöründe rekabetçi fiyat ve hızlı teslimat.',
    solution: 'Kullanıcı odaklı UX, hızlı checkout, sadakat programı.',
    results: ['%260 dönüşüm artışı', '%180 sepet değeri', 'Müşteri sadakati'],
    services: ['E-Ticaret', 'UX/UI', 'Web Geliştirme'],
    year: '2024',
  },
  {
    id: 'alya-butik-otel',
    slug: 'alya-butik-otel',
    title: 'Alya Butik Otel',
    client: 'Alya Butik Otel',
    category: 'tourism',
    categoryLabel: 'Turizm & Otel',
    image: '/projects/alya-butik-otel.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194573549/Medyatik-Alya-Butik-Otel',
    metric: '+380%',
    metricLabel: 'Rezervasyon',
    description: 'Butik otel için web sitesi ve online rezervasyon sistemi.',
    challenge: 'Butik otel atmosferini dijitale yansıtma ve direkt rezervasyon artışı.',
    solution: 'Görsel odaklı tasarım, sanal tur, anlık müsaitlik ve fiyat gösterimi.',
    results: ['%380 rezervasyon artışı', '%250 direkt booking', 'OTA bağımlılığı azaldı'],
    services: ['Web Tasarım', 'Rezervasyon Sistemi', 'Fotoğrafçılık'],
    year: '2024',
  },
  {
    id: 'umit-usta',
    slug: 'umit-usta-pastaneleri',
    title: 'Ümit Usta Pastaneleri',
    client: 'Ümit Usta',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/umit-usta.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194572395/Medyatik-UEmit-Usta-Pastaneleri',
    metric: '+290%',
    metricLabel: 'Online Sipariş',
    description: 'Pastane zinciri için web sitesi ve online sipariş sistemi.',
    challenge: 'Geleneksel pastane deneyimini dijitale taşıma.',
    solution: 'Görsel ürün kataloğu, özel gün siparişi, şube bulucu.',
    results: ['%290 online sipariş', '%200 marka bilinirliği', 'Dijital dönüşüm'],
    services: ['Web Tasarım', 'E-Sipariş', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'zoovital',
    slug: 'zoovital',
    title: 'ZooVital',
    client: 'ZooVital',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/zoovital.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194568399/Medyatik-ZooVital',
    metric: '+320%',
    metricLabel: 'Satış',
    description: 'Pet sağlık ürünleri e-ticaret platformu.',
    challenge: 'Pet sağlık ürünlerinde güven ve uzman bilgisi sunumu.',
    solution: 'Veteriner onaylı içerik, ürün karşılaştırma, abonelik modeli.',
    results: ['%320 satış artışı', '%240 müşteri sadakati', 'Sektör otoritesi'],
    services: ['E-Ticaret', 'İçerik Stratejisi', 'SEO'],
    year: '2024',
  },
  {
    id: 'skyfall-lounge',
    slug: 'skyfall-lounge',
    title: 'Skyfall Lounge',
    client: 'Skyfall Lounge',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/skyfall-lounge.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194564539/Medyatik-Skyfall-Lounge',
    metric: '+400%',
    metricLabel: 'Rezervasyon',
    description: 'Premium lounge için web sitesi ve dijital pazarlama.',
    challenge: 'Lüks segment hedef kitleye ulaşım ve marka konumlandırma.',
    solution: 'Premium görsel dil, VIP rezervasyon sistemi, influencer stratejisi.',
    results: ['%400 rezervasyon artışı', 'Premium marka algısı', 'Sosyal medya etkisi'],
    services: ['Web Tasarım', 'Dijital Pazarlama', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'golevi-restaurant',
    slug: 'golevi-restaurant',
    title: 'Gölevi Restaurant',
    client: 'Gölevi',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/golevi-restaurant.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194563605/Medyatik-Goelevi-Restaurant',
    metric: '+350%',
    metricLabel: 'Masa Rezervasyonu',
    description: 'Göl manzaralı restoran için web sitesi ve rezervasyon sistemi.',
    challenge: 'Doğa ve lezzeti bir arada sunan deneyimin dijitale yansıması.',
    solution: 'Drone çekimleri, 360° görünüm, anlık masa durumu gösterimi.',
    results: ['%350 rezervasyon artışı', '%280 sosyal paylaşım', 'Bölgesel otorite'],
    services: ['Web Tasarım', 'Rezervasyon', 'Fotoğraf/Video'],
    year: '2024',
  },
  {
    id: 'reborn-beauty',
    slug: 'reborn-beauty',
    title: 'Reborn Beauty',
    client: 'Reborn Beauty',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/reborn-beauty.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194562305/Medyatik-Reborn-Beauty',
    metric: '+280%',
    metricLabel: 'Randevu',
    description: 'Güzellik merkezi için web sitesi ve online randevu sistemi.',
    challenge: 'Premium güzellik hizmetlerinin dijital sunumu ve randevu yönetimi.',
    solution: 'Önce/sonra galeri, hizmet paketi karşılaştırma, kolay randevu.',
    results: ['%280 randevu artışı', '%200 müşteri memnuniyeti', 'Marka güçlenmesi'],
    services: ['Web Tasarım', 'Randevu Sistemi', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'ozpay-gross',
    slug: 'ozpay-gross-marketleri',
    title: 'Özpay Gross Marketleri',
    client: 'Özpay',
    category: 'retail',
    categoryLabel: 'Perakende',
    image: '/projects/ozpay-gross.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194562141/Medyatik-OEzpay-Gross-Marketleri',
    metric: '+180%',
    metricLabel: 'Trafik',
    description: 'Gross market zinciri için dijital varlık ve sosyal medya yönetimi.',
    challenge: 'Yerel market zincirinin dijital görünürlüğü ve müşteri sadakati.',
    solution: 'Haftalık kampanya duyuruları, şube bulucu, sadakat programı.',
    results: ['%180 web trafiği', '%150 kampanya etkileşimi', 'Müşteri sadakati'],
    services: ['Web Tasarım', 'Sosyal Medya', 'Kampanya Yönetimi'],
    year: '2024',
  },
  {
    id: 'maryap-gyo',
    slug: 'maryap-gyo',
    title: 'Maryap GYO',
    client: 'Maryap',
    category: 'realestate',
    categoryLabel: 'Gayrimenkul',
    image: '/projects/maryap-gyo.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194561287/Medyatik-Maryap-GYO',
    metric: '+240%',
    metricLabel: 'Lead',
    description: 'Gayrimenkul yatırım ortaklığı için kurumsal web sitesi.',
    challenge: 'Yatırımcı güveni ve proje portföyünün profesyonel sunumu.',
    solution: 'Interaktif proje haritası, yatırımcı ilişkileri portalı, finansal raporlar.',
    results: ['%240 lead artışı', 'Yatırımcı güveni', 'Kurumsal itibar'],
    services: ['Kurumsal Web', 'Yatırımcı İlişkileri', 'İçerik'],
    year: '2024',
  },
  {
    id: 'livera-energy',
    slug: 'livera-energy',
    title: 'Livera Energy',
    client: 'Livera',
    category: 'energy',
    categoryLabel: 'Enerji',
    image: '/projects/livera-energy.png',
    behanceUrl: 'https://www.behance.net/gallery/194560957/Medyatik-Livera-Energy',
    metric: '+200%',
    metricLabel: 'Talep',
    description: 'Enerji şirketi için kurumsal web sitesi ve B2B pazarlama.',
    challenge: 'Enerji sektöründe B2B müşteri kazanımı ve güvenilirlik.',
    solution: 'Teknik katalog, referans projeleri, online teklif talebi.',
    results: ['%200 talep artışı', 'B2B ilişkiler', 'Sektör otoritesi'],
    services: ['Kurumsal Web', 'B2B Pazarlama', 'Katalog'],
    year: '2024',
  },
  // ===== SAYFA 3 (25-36) =====
  {
    id: 'elektromarket',
    slug: 'elektromarket-ledmarketim',
    title: 'Elektromarket - Ledmarketim',
    client: 'Ledmarketim',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/elektromarket.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194560675/Medyatik-Elektromarket-Ledmarketim',
    metric: '+290%',
    metricLabel: 'Satış',
    description: 'LED ve elektrik ürünleri e-ticaret platformu.',
    challenge: 'Teknik ürünlerin anlaşılır sunumu ve kolay satın alma.',
    solution: 'Teknik filtreler, karşılaştırma aracı, B2B fiyatlandırma.',
    results: ['%290 satış artışı', '%200 B2B müşteri', 'Teknik otorite'],
    services: ['E-Ticaret', 'Web Geliştirme', 'SEO'],
    year: '2024',
  },
  {
    id: 'kitirmama',
    slug: 'kitirmama',
    title: 'KıtırMama',
    client: 'KıtırMama',
    category: 'ecommerce',
    categoryLabel: 'E-Ticaret',
    image: '/projects/kitirmama.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194560013/Medyatik-KtrMama',
    metric: '+320%',
    metricLabel: 'Sipariş',
    description: 'Pet mama e-ticaret platformu ve marka kimliği.',
    challenge: 'Pet mama sektöründe farklılaşma ve güven oluşturma.',
    solution: 'İçerik analizi, veteriner onaylı ürünler, abonelik modeli.',
    results: ['%320 sipariş artışı', '%250 abonelik', 'Marka sadakati'],
    services: ['E-Ticaret', 'Kurumsal Kimlik', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'katikci-baba',
    slug: 'katikci-baba',
    title: 'Katıkçı Baba',
    client: 'Katıkçı Baba',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/katikci-baba.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194559817/Medyatik-Katkc-Baba',
    metric: '+280%',
    metricLabel: 'Dönüşüm',
    description: 'Geleneksel gıda markası için web sitesi ve e-ticaret.',
    challenge: 'Geleneksel lezzetlerin modern dijital platformda sunumu.',
    solution: 'Hikaye odaklı içerik, üretim süreci videoları, taze teslimat.',
    results: ['%280 dönüşüm', '%200 marka bilinirliği', 'Geleneksel değer'],
    services: ['Web Tasarım', 'E-Ticaret', 'İçerik'],
    year: '2024',
  },
  {
    id: 'kasaphan',
    slug: 'kasaphan-steak-house',
    title: 'Kasaphan Steak House',
    client: 'Kasaphan',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/kasaphan.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194558161/Medyatik-Kasaphan-Steak-House',
    metric: '+350%',
    metricLabel: 'Rezervasyon',
    description: 'Premium steak house için web sitesi ve dijital pazarlama.',
    challenge: 'Premium restoran deneyiminin dijital yansıması.',
    solution: 'Yüksek kalite fotoğraflar, menü sunumu, VIP rezervasyon.',
    results: ['%350 rezervasyon', 'Premium marka algısı', 'Sosyal etki'],
    services: ['Web Tasarım', 'Fotoğrafçılık', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'prof-tonguc-isken',
    slug: 'prof-dr-tonguc-isken',
    title: 'Prof. Dr. Tonguç İŞKEN',
    client: 'Prof. Dr. Tonguç İŞKEN',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/prof-tonguc-isken.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194551739/Prof-Dr-Tonguc-SKEN',
    metric: '+220%',
    metricLabel: 'Hasta Başvurusu',
    description: 'Estetik cerrah için kişisel web sitesi ve hasta yönetimi.',
    challenge: 'Uzmanlık alanının güvenilir sunumu ve hasta çekimi.',
    solution: 'Önce/sonra galeri, video testimonial, online konsültasyon.',
    results: ['%220 hasta başvurusu', '%180 uluslararası hasta', 'Uzman otoritesi'],
    services: ['Kişisel Web', 'Hasta Yönetimi', 'Dijital Pazarlama'],
    year: '2024',
  },
  {
    id: 'vitamor',
    slug: 'medical-park-vitamor',
    title: 'Medical Park - Vitamor Estetik Merkezi',
    client: 'Vitamor',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/vitamor.png',
    behanceUrl: 'https://www.behance.net/gallery/194551551/Medyatik-Medical-Park-Vitamor-Estetik-Merkezi',
    metric: '+300%',
    metricLabel: 'Randevu',
    description: 'Estetik merkezi için web sitesi ve dijital pazarlama stratejisi.',
    challenge: 'Estetik hizmetlerinde güven ve profesyonellik sunumu.',
    solution: 'Doktor profilleri, işlem videoları, online randevu sistemi.',
    results: ['%300 randevu artışı', '%240 marka güveni', 'Sektör liderliği'],
    services: ['Web Tasarım', 'Dijital Pazarlama', 'Video İçerik'],
    year: '2024',
  },
  {
    id: 'neslihan-turkoglu',
    slug: 'diyetisyen-neslihan-turkoglu',
    title: 'Bariatrik Diyetisyen Neslihan TÜRKOĞLU',
    client: 'Neslihan TÜRKOĞLU',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/neslihan-turkoglu.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194551203/Medyatik-Bariatrik-Diyetisyen-Neslihan-TUERKOGLU',
    metric: '+250%',
    metricLabel: 'Danışan',
    description: 'Bariatrik diyetisyen için kişisel marka ve web sitesi.',
    challenge: 'Uzman diyetisyen olarak dijital varlık oluşturma.',
    solution: 'Blog içerikleri, başarı hikayeleri, online diyet programı.',
    results: ['%250 danışan artışı', '%200 sosyal takipçi', 'Uzman otoritesi'],
    services: ['Kişisel Web', 'İçerik Pazarlama', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'gurdal-oren',
    slug: 'medicana-dr-gurdal-oren',
    title: 'Medicana Dr. Gürdal Ören - Bariatrik Cerrahi',
    client: 'Dr. Gürdal Ören',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/prof-tonguc-isken.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194550943/Medyatik-Medicana-Dr-Guerdal-OEren-Bariatrik-Cerrahi',
    metric: '+280%',
    metricLabel: 'Hasta',
    description: 'Bariatrik cerrah için web sitesi ve hasta yönetimi.',
    challenge: 'Obezite cerrahisinde güven ve bilgilendirme.',
    solution: 'Hasta hikayeleri, işlem animasyonları, uzaktan konsültasyon.',
    results: ['%280 hasta artışı', '%200 uluslararası hasta', 'Güvenilirlik'],
    services: ['Kişisel Web', 'Video İçerik', 'Hasta Yönetimi'],
    year: '2024',
  },
  {
    id: 'derindere-hastanesi',
    slug: 'derindere-hastanesi',
    title: 'Derindere Hastanesi',
    client: 'Derindere Hastanesi',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/derindere-hastanesi.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194550445/Medyatik-Derindere-Hastanesi',
    metric: '+200%',
    metricLabel: 'Web Trafiği',
    description: 'Özel hastane için kurumsal web sitesi ve dijital varlık.',
    challenge: 'Sağlık sektöründe güvenilir kurumsal imaj.',
    solution: 'Departman tanıtımları, doktor profilleri, online randevu.',
    results: ['%200 web trafiği', '%180 randevu artışı', 'Kurumsal güven'],
    services: ['Kurumsal Web', 'SEO', 'Randevu Sistemi'],
    year: '2024',
  },
  {
    id: 'atakent-hastanesi',
    slug: 'atakent-hastanesi',
    title: 'Atakent Hastanesi',
    client: 'Atakent Hastanesi',
    category: 'healthcare',
    categoryLabel: 'Sağlık & Güzellik',
    image: '/projects/atakent-hastanesi.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194549965/Medyatik-Atakent-Hastanesi',
    metric: '+180%',
    metricLabel: 'Hasta Memnuniyeti',
    description: 'Hastane için web sitesi yenileme ve dijital dönüşüm.',
    challenge: 'Mevcut web sitesinin modernizasyonu ve kullanıcı deneyimi.',
    solution: 'Modern tasarım, mobil uyumluluk, hızlı randevu sistemi.',
    results: ['%180 hasta memnuniyeti', '%150 web trafiği', 'Modern imaj'],
    services: ['Web Tasarım', 'UX/UI', 'Mobil Optimizasyon'],
    year: '2024',
  },
  {
    id: 'opark',
    slug: 'opark-yasam-merkezi',
    title: 'OPARK - Yaşam Merkezi',
    client: 'OPARK',
    category: 'realestate',
    categoryLabel: 'Gayrimenkul',
    image: '/projects/opark.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194548949/Medyatik-OPARK-Yasam-Merkezi',
    metric: '+320%',
    metricLabel: 'Lead',
    description: 'Yaşam merkezi projesi için tanıtım sitesi ve dijital pazarlama.',
    challenge: 'Büyük ölçekli gayrimenkul projesinin etkileyici sunumu.',
    solution: '3D görselleştirme, sanal tur, online satış danışmanı.',
    results: ['%320 lead artışı', '%280 proje ilgisi', 'Başarılı lansman'],
    services: ['Proje Tanıtım', '3D Görsel', 'Dijital Pazarlama'],
    year: '2024',
  },
  {
    id: 'nokta-tv',
    slug: 'nokta-tv-gazetesi',
    title: 'Nokta TV - Nokta Gazetesi',
    client: 'Nokta Medya',
    category: 'media',
    categoryLabel: 'Medya',
    image: '/projects/nokta-tv.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194548729/Medyatik-Nokta-TV-Nokta-Gazetesi',
    metric: '+400%',
    metricLabel: 'Okuyucu',
    description: 'Haber portalı ve TV kanalı için dijital platform.',
    challenge: 'Çok kanallı medya içeriğinin entegre sunumu.',
    solution: 'Haber portalı, canlı yayın entegrasyonu, mobil uygulama.',
    results: ['%400 okuyucu artışı', '%300 video izlenme', 'Dijital dönüşüm'],
    services: ['Haber Portalı', 'Mobil Uygulama', 'Video Platform'],
    year: '2024',
  },
  // ===== SAYFA 4 (37-46) =====
  {
    id: 'ekin-backerei',
    slug: 'ekin-backerei',
    title: 'Ekin Backerei',
    client: 'Ekin Backerei',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/ekin-backerei.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194548419/Medyatik-Ekin-Backerei',
    metric: '+260%',
    metricLabel: 'Sipariş',
    description: 'Alman fırın markası için kurumsal kimlik ve web sitesi.',
    challenge: 'Almanya\'daki Türk fırını için marka konumlandırma.',
    solution: 'İki dilli site, online sipariş, kültürel köprü konsepti.',
    results: ['%260 sipariş artışı', 'Marka bilinirliği', 'Topluluk bağı'],
    services: ['Kurumsal Kimlik', 'Web Tasarım', 'E-Sipariş'],
    year: '2024',
  },
  {
    id: 'chefistanbul',
    slug: 'chefistanbul',
    title: 'Chefİstanbul',
    client: 'Chefİstanbul',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/chefistanbul.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194547913/Medyatik-Chefstanbul',
    metric: '+300%',
    metricLabel: 'Etkinlik Katılımı',
    description: 'Yemek workshopları ve şef etkinlikleri platformu.',
    challenge: 'Gastronomi etkinliklerinin dijital pazarlanması.',
    solution: 'Etkinlik takvimi, online rezervasyon, şef profilleri.',
    results: ['%300 etkinlik katılımı', '%240 sosyal etkileşim', 'Topluluk oluşumu'],
    services: ['Web Tasarım', 'Etkinlik Yönetimi', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'baristaplus',
    slug: 'baristaplus',
    title: 'Baristaplus',
    client: 'Baristaplus',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/baristaplus.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194547427/Medyatik-Baristaplus',
    metric: '+280%',
    metricLabel: 'Satış',
    description: 'Kahve ekipmanları e-ticaret platformu.',
    challenge: 'Profesyonel kahve ekipmanlarının B2B ve B2C satışı.',
    solution: 'Ürün karşılaştırma, teknik rehberler, B2B fiyatlandırma.',
    results: ['%280 satış artışı', '%200 B2B müşteri', 'Sektör otoritesi'],
    services: ['E-Ticaret', 'İçerik Pazarlama', 'B2B'],
    year: '2024',
  },
  {
    id: 'kollektif-house',
    slug: 'kollektif-house',
    title: 'Kollektif House - Sanal Ofis',
    client: 'Kollektif House',
    category: 'corporate',
    categoryLabel: 'Kurumsal',
    image: '/projects/kollektif-house.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194546935/Medyatik-Kollektif-House-Sanal-Ofis',
    metric: '+350%',
    metricLabel: 'Üyelik',
    description: 'Co-working ve sanal ofis hizmetleri platformu.',
    challenge: 'Sanal ofis hizmetlerinin anlaşılır ve çekici sunumu.',
    solution: 'Paket karşılaştırma, sanal tur, online üyelik sistemi.',
    results: ['%350 üyelik artışı', '%280 sanal ofis talebi', 'Pazar liderliği'],
    services: ['Web Tasarım', 'Üyelik Sistemi', 'Dijital Pazarlama'],
    year: '2024',
  },
  {
    id: 'jolly-joker',
    slug: 'jolly-joker',
    title: 'Jolly Joker',
    client: 'Jolly Joker',
    category: 'entertainment',
    categoryLabel: 'Eğlence',
    image: '/projects/jolly-joker.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194546487/Medyatik-Jolly-Joker',
    metric: '+400%',
    metricLabel: 'Bilet Satışı',
    description: 'Efsanevi müzik mekanı için dijital varlık ve bilet sistemi.',
    challenge: 'Canlı müzik mekanının dijital dönüşümü ve bilet satışı.',
    solution: 'Etkinlik takvimi, online bilet, artist showcase.',
    results: ['%400 bilet satışı', '%300 sosyal etkileşim', 'Marka yenilenmesi'],
    services: ['Web Tasarım', 'Bilet Sistemi', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'izaydas',
    slug: 'izaydas',
    title: 'İZAYDAŞ',
    client: 'İZAYDAŞ',
    category: 'corporate',
    categoryLabel: 'Kurumsal',
    image: '/projects/izaydas.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194546149/Medyatik-ZAYDAS',
    metric: '+180%',
    metricLabel: 'Kurumsal İletişim',
    description: 'Çevre ve atık yönetimi şirketi için kurumsal web sitesi.',
    challenge: 'Kamu kurumu kimliğinin modern dijital platformda sunumu.',
    solution: 'Şeffaflık odaklı içerik, çevre raporları, vatandaş portalı.',
    results: ['%180 web etkileşimi', 'Şeffaflık algısı', 'Vatandaş memnuniyeti'],
    services: ['Kurumsal Web', 'İçerik Stratejisi', 'Portal'],
    year: '2024',
  },
  {
    id: 'elbet-steak',
    slug: 'elbet-steak-house',
    title: 'Elbet Steak House',
    client: 'Elbet',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/elbet-steak.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194545651/Medyatik-Elbet-Steak-House',
    metric: '+320%',
    metricLabel: 'Rezervasyon',
    description: 'Steak house için web sitesi ve dijital pazarlama.',
    challenge: 'Et restoranı deneyiminin dijital sunumu.',
    solution: 'Menü görselleştirme, şef hikayeleri, VIP rezervasyon.',
    results: ['%320 rezervasyon', '%250 sosyal takipçi', 'Marka güçlenmesi'],
    services: ['Web Tasarım', 'Fotoğrafçılık', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'sketchplus-cafe',
    slug: 'sketchplus-cafe',
    title: 'SketchPlus Cafe',
    client: 'SketchPlus',
    category: 'food',
    categoryLabel: 'Yeme & İçme',
    image: '/projects/sketchplus-cafe.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194544955/Medyatik-SketchPlus-Cafe',
    metric: '+280%',
    metricLabel: 'Ziyaretçi',
    description: 'Konsept kafe için marka kimliği ve dijital varlık.',
    challenge: 'Sanat ve kahve konseptinin entegre sunumu.',
    solution: 'Görsel odaklı tasarım, etkinlik takvimi, Instagram entegrasyonu.',
    results: ['%280 ziyaretçi artışı', '%350 Instagram etkileşimi', 'Trend mekan'],
    services: ['Kurumsal Kimlik', 'Web Tasarım', 'Sosyal Medya'],
    year: '2024',
  },
  {
    id: 'golden-palace',
    slug: 'golden-palace-hotel',
    title: 'Golden Palace Hotel',
    client: 'Golden Palace',
    category: 'tourism',
    categoryLabel: 'Turizm & Otel',
    image: '/projects/golden-palace.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194544363/Medyatik-Golden-Palace-Hotel',
    metric: '+380%',
    metricLabel: 'Direkt Rezervasyon',
    description: 'Lüks otel için web sitesi ve online rezervasyon sistemi.',
    challenge: 'Lüks otel deneyiminin dijitale yansıması ve OTA bağımlılığının azaltılması.',
    solution: 'Sanal oda turu, özel fırsatlar, sadakat programı entegrasyonu.',
    results: ['%380 direkt rezervasyon', '%50 OTA komisyon tasarrufu', 'Marka değeri'],
    services: ['Web Tasarım', 'Rezervasyon Sistemi', 'Dijital Pazarlama'],
    year: '2024',
  },
  {
    id: 'garnet-home',
    slug: 'garnet-home-design',
    title: 'Garnet Home Design',
    client: 'Garnet Home',
    category: 'retail',
    categoryLabel: 'Perakende',
    image: '/projects/garnet-home.jpg',
    behanceUrl: 'https://www.behance.net/gallery/194544117/Medyatik-Garnet-Home-Design',
    metric: '+290%',
    metricLabel: 'Online Satış',
    description: 'Ev dekorasyon markası için e-ticaret platformu.',
    challenge: 'Ev dekorasyon ürünlerinin görsel çekicilikte sunumu.',
    solution: 'Oda konseptleri, stil rehberi, AR ürün önizleme.',
    results: ['%290 online satış', '%220 sepet değeri', 'Stil otoritesi'],
    services: ['E-Ticaret', 'UX/UI', 'İçerik Pazarlama'],
    year: '2024',
  },
];

// Kategori listesi
export const categories = [
  { id: 'all', name: 'Tüm Projeler', count: 46 },
  { id: 'healthcare', name: 'Sağlık & Güzellik', count: 10 },
  { id: 'ecommerce', name: 'E-Ticaret', count: 10 },
  { id: 'food', name: 'Yeme & İçme', count: 10 },
  { id: 'tourism', name: 'Turizm & Otel', count: 3 },
  { id: 'branding', name: 'Marka & Kurumsal', count: 2 },
  { id: 'realestate', name: 'Gayrimenkul', count: 2 },
  { id: 'corporate', name: 'Kurumsal', count: 2 },
  { id: 'retail', name: 'Perakende', count: 2 },
  { id: 'media', name: 'Medya', count: 1 },
  { id: 'entertainment', name: 'Eğlence', count: 1 },
  { id: 'energy', name: 'Enerji', count: 1 },
  { id: 'political', name: 'Siyasi Kampanya', count: 1 },
  { id: 'event', name: 'Etkinlik', count: 1 },
];

// Proje slug'a göre bul
export const getProjectBySlug = (slug) => {
  return allProjects.find(p => p.slug === slug);
};

// Kategoriye göre filtrele
export const getProjectsByCategory = (categoryId) => {
  if (categoryId === 'all') return allProjects;
  return allProjects.filter(p => p.category === categoryId);
};

// Öne çıkan projeler (ana sayfa için)
export const featuredProjects = allProjects.slice(0, 6);

export default allProjects;
